@if (!allOptionsHidden()) {
  @switch (itemMenuStyle()) {
    @case (ItemMenuStyle.BUTTON) {
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        (click)="stopPropagationEvent($event)"
      >
        <mat-icon svgIcon="twc:more" class="twc-color-secondary-typeface" />
      </button>
    }
    @case (ItemMenuStyle.ICON) {
      <mat-icon
        [matMenuTriggerFor]="menu"
        (click)="stopPropagationEvent($event)"
        svgIcon="twc:more"
        class="twc-color-secondary-typeface"
      />
    }
  }
}

<mat-menu #menu="matMenu">
  @for (action of items(); track action.name) {
    @if (
      (action?.hidden && !action.hidden(actionArgument())) || !action?.hidden
    ) {
      @if (action.permission) {
        <ng-container *permissionSingleOrEvery="action.permission">
          @if (action.divider) {
            <hr class="divider" />
          }
          <button
            mat-menu-item
            [disabled]="
              action.disabled ? action.disabled(actionArgument()) : false
            "
            (click)="action.method(actionArgument())"
            class="item-menu-button"
            [ngClass]="{
              'item-menu-button-prefix':
                action.icon?.position === TableActionEntityIconPosition.PREFIX,
              'item-menu-button-suffix':
                action.icon?.position === TableActionEntityIconPosition.SUFFIX,
            }"
          >
            @if (action?.icon) {
              <!-- Single wrapper keeps the icon in mat-menu-item's default slot, next to the label. -->
              <ng-container>
                <mat-icon
                  [class]="action?.icon?.className"
                  [svgIcon]="action.icon.name"
                />
                <span>{{ action.name }}</span>
              </ng-container>
            } @else if (action?.icons) {
              <ng-container
                [ngTemplateOutlet]="actionWithMultipleButtons"
                [ngTemplateOutletContext]="{ action: action }"
              ></ng-container>
            } @else {
              {{ action.name }}
            }
          </button>
        </ng-container>
      } @else {
        @if (action.divider) {
          <hr class="divider" />
        }
        <button
          mat-menu-item
          [disabled]="
            action.disabled ? action.disabled(actionArgument()) : false
          "
          (click)="action.method(actionArgument())"
          class="item-menu-button"
          [ngClass]="{
            'item-menu-button-prefix':
              action.icon?.position === TableActionEntityIconPosition.PREFIX,
            'item-menu-button-suffix':
              action.icon?.position === TableActionEntityIconPosition.SUFFIX,
          }"
        >
          @if (action?.icon) {
            <!-- Single wrapper keeps the icon in mat-menu-item's default slot, next to the label. -->
            <ng-container>
              <mat-icon
                [class]="action?.icon?.className"
                [svgIcon]="action.icon.name"
              />
              <span>{{ action.name }}</span>
            </ng-container>
          } @else if (action?.icons) {
            <ng-container
              [ngTemplateOutlet]="actionWithMultipleButtons"
              [ngTemplateOutletContext]="{ action: action }"
            ></ng-container>
          } @else {
            {{ action.name }}
          }
        </button>
      }
    }
  }
</mat-menu>

<ng-template #actionWithMultipleButtons let-action="action">
  @if (Array.isArray(action.icons)) {
    @for (icon of action.icons; track icon.name) {
      @if (icon.position === TableActionEntityIconPosition.PREFIX) {
        <mat-icon [class]="icon?.className" [svgIcon]="icon.name" />
      }
    }
  }
  <span>{{ action.name }}</span>
  @if (Array.isArray(action.icons)) {
    @for (icon of action.icons; track icon.name) {
      @if (icon.position === TableActionEntityIconPosition.SUFFIX) {
        <mat-icon [class]="icon?.className" [svgIcon]="icon.name" />
      }
    }
  }
</ng-template>
